import React from 'react';
import { TweenMax } from 'gsap';

const FancyToggle = (props) => {

    const toggleNo = (event) => {
        event.preventDefault();
        let slider = document.getElementById('toggle-slider'),
            checkbox = document.getElementById('toggle-checkbox');

        TweenMax.to(slider, 0.2, {x: '0%'});
        checkbox.checked = false;
        props.setValue('no');
    };

    const toggleYes = (event) => {
        event.preventDefault();
        let container = document.querySelector('.fancy-toggle .toggle'),
            slider = document.getElementById('toggle-slider'),
            checkbox = document.getElementById('toggle-checkbox');

        container.style.borderColor = '#004346';
        TweenMax.to(slider, 0.2, {x: '-100%'});
        checkbox.checked = true;
        props.setValue('yes');
    };

    return (
        <div className="fancy-toggle">
            <div className="title input-label-styled">{props.title}</div>
            <div className="toggle">
                <div className="toggle-slider" id="toggle-slider" />
                <a href="#" className="toggle-item" onClick={toggleYes.bind(this)}>
                    Yes
                </a>
                <a href="#" className="toggle-item active" onClick={toggleNo.bind(this)}>
                    No
                </a>
                <input type="checkbox" id="toggle-checkbox" name={props.name} value="1" />
            </div>
        </div>
    );

};

export default FancyToggle;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/FancyToggle.js